/**
 * Utilitários para manipulação de imagens
 */

/**
 * Obtém a URL base da API sem o sufixo /api
 * @returns {string} URL base da API
 */
export const getApiBaseUrl = () => {
  // Desenvolvimento
  if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    return 'http://localhost:3001';
  }
  // Produção
  return 'https://api.ibe.elshadaysystems.com.br';
};

/**
 * Constrói a URL completa de uma foto de perfil
 * @param {string|null} photoPath - Caminho relativo da foto (ex: /uploads/profile-photos/photo.jpg)
 * @param {string} defaultImage - Imagem padrão caso photoPath seja null
 * @returns {string} URL completa da foto
 */
export const getPhotoUrl = (photoPath, defaultImage = '/assets/images/avatar-usuario.png') => {
  if (!photoPath) {
    return defaultImage;
  }
  
  return `${getApiBaseUrl()}${photoPath}`;
};

/**
 * Valida se um arquivo é uma imagem válida
 * @param {File} file - Arquivo a ser validado
 * @param {number} maxSizeMB - Tamanho máximo em MB (padrão: 5)
 * @returns {Object} { valid: boolean, error: string|null }
 */
export const validateImageFile = (file, maxSizeMB = 5) => {
  // Verificar se é imagem
  const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/gif'];
  if (!allowedTypes.includes(file.type)) {
    return {
      valid: false,
      error: 'Por favor, selecione uma imagem válida (JPG, PNG ou GIF)'
    };
  }

  // Verificar tamanho
  const maxSize = maxSizeMB * 1024 * 1024; // Converter MB para bytes
  if (file.size > maxSize) {
    return {
      valid: false,
      error: `A imagem deve ter no máximo ${maxSizeMB}MB`
    };
  }

  return { valid: true, error: null };
};

/**
 * Cria um preview de imagem usando FileReader
 * @param {File} file - Arquivo de imagem
 * @returns {Promise<string>} Promise que resolve com a data URL da imagem
 */
export const createImagePreview = (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onloadend = () => {
      resolve(reader.result);
    };
    
    reader.onerror = () => {
      reject(new Error('Erro ao ler arquivo'));
    };
    
    reader.readAsDataURL(file);
  });
};
